// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order.
//
// Saklaw ng file na ito: ang time-slots grid — pag-render, slot selection,
// at sarili nitong keyboard nav binding.
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const CONFIG = DP.CONFIG;
  const state = DP.state;

  function clearSelectedTime() {
    const { timeHidden, timeContainer } = state.elements;

    if (timeHidden) timeHidden.value = "";

    if (timeContainer) {
      timeContainer.querySelectorAll(".time-slot-card.active").forEach((item) => {
        item.classList.remove("active");
      });
    }

    DP.syncSelectorDisplays();
  }

  // Hakbang 3 (2026-09-02): window.today at window.cutoffAt direkta — walang
  // lokal na "now" na dayjs snapshot, dayjs formatter na lang sa buong file.
  function getTodayAvailabilityMessage(selectedDate) {
    if (!selectedDate) return "";

    const availability = state.availability;
    if (!availability || selectedDate !== availability.today) return "";

    const cutoffMs = Date.parse(availability.cutoffAt);
    if (Number.isFinite(cutoffMs) && Date.now() >= cutoffMs) {
      return "Same-day delivery cutoff passed. Choose tomorrow.";
    }

    return "";
  }

  function formatSlotParts(display, omitDash) {
    const parts = typeof display === "string" ? display.split("-") : [];
    if (parts.length !== 2) return { start: display || "", end: "" };

    const endText = parts[1].trim();
    // Muted (Full/Cut-off) na slots ay may line-through strikethrough na sa
    // buong text (@990+ CSS) — redundant na ang em dash bilang range
    // separator kapag naka-cross-out na.
    return { start: parts[0].trim(), end: omitDash ? endText : `–${endText}` };
  }

  function renderTimeSlots(selectedDate, isInitialLoad = false) {
    DP.toggleError(null);

    const { timeContainer, timeHidden } = state.elements;
    if (!timeContainer) return;

    if (!isInitialLoad) {
      clearSelectedTime();
    }

    const hadFocus = timeContainer.contains(document.activeElement);
    timeContainer.innerHTML = "";

    const now = DP.getNowPH();
    const isNoDateSelected = !selectedDate;
    let hasAvailableSlots = false;
    let firstAvailableEl = null;
    let selectedEl = null;

    const availabilityMessage = getTodayAvailabilityMessage(selectedDate);
    if (availabilityMessage) {
      DP.toggleError(availabilityMessage);
    }

    // Ang PINAKA-UNANG available na slot ng NEAREST-BOOKABLE DATE lang
    // (kahit ilan ang na-skip na Full o Cut-off bago ito) ay makakakuha ng
    // "Closes soon" urgency badge (2026-08-31 owner request, na-scope
    // 2026-09-01 sa nearest-bookable date lang — dating lumalabas ito sa
    // KAHIT ANONG petsang tinitingnan, kaya nangangako ng maling urgency sa
    // mga advance order na malayo pa. Ang nearest-bookable date ay karaniwang
    // Today; lumilipat lang ito kapag naka-block/puno ang Today).
    const nearestBookableDate = DP.getNearestBookableDate(now);
    let closesSoonPending = !isNoDateSelected && selectedDate === nearestBookableDate;

    CONFIG.slots.forEach((slot) => {
      const el = document.createElement("div");
      el.className = "time-slot-card";
      el.setAttribute("role", "option");

      const isSlotDisabled =
        isNoDateSelected || !DP.isSlotAvailable(selectedDate, slot.value, now);

      const parts = formatSlotParts(slot.display, isSlotDisabled);

      const startEl = document.createElement("span");
      startEl.className = "time-slot-card__start";
      startEl.textContent = parts.start;

      const endEl = document.createElement("span");
      endEl.className = "time-slot-card__end";
      endEl.textContent = parts.end;

      el.appendChild(startEl);
      el.appendChild(endEl);

      if (isSlotDisabled) {
        el.classList.add("muted");
        el.setAttribute("aria-disabled", "true");
        el.setAttribute("aria-selected", "false");
        el.setAttribute("tabindex", "-1");
      } else {
        hasAvailableSlots = true;
        el.setAttribute("aria-disabled", "false");
        el.setAttribute("aria-selected", "false");
        el.setAttribute("tabindex", "-1");

        if (!firstAvailableEl) firstAvailableEl = el;

        if (timeHidden && timeHidden.value === slot.value) {
          el.classList.add("active");
          el.setAttribute("aria-selected", "true");
          el.setAttribute("tabindex", "0");
          selectedEl = el;
        }

        el.addEventListener("click", () => {
          timeContainer.querySelectorAll(".time-slot-card").forEach((item) => {
            item.classList.remove("active");
            item.setAttribute("aria-selected", "false");
            item.setAttribute("tabindex", "-1");
          });

          el.classList.add("active");
          el.setAttribute("aria-selected", "true");
          el.setAttribute("tabindex", "0");

          if (timeHidden) timeHidden.value = slot.value;

          DP.toggleError(null);
          DP.syncSelectorDisplays();
          void DP.updateCart(DP.buildCartPayload(), "time-slot");
        });
      }

      if (!isNoDateSelected) {
        const slotStatus = DP.getSlotStatus(selectedDate, slot.value, now);

        if (slotStatus.full) {
          const statusEl = document.createElement("span");
          statusEl.className = "time-slot-card__status";
          statusEl.textContent = "Full";
          el.appendChild(statusEl);
        } else if (!isSlotDisabled && closesSoonPending) {
          slotStatus.closesSoon = true;
          closesSoonPending = false;
        }

        if (slotStatus.cutoffPassed) {
          const statusEl = document.createElement("span");
          statusEl.className = "time-slot-card__status";
          statusEl.textContent = "Cut-off";
          el.appendChild(statusEl);
        }

        if (slotStatus.closesSoon) {
          const badgeEl = document.createElement("span");
          badgeEl.className = "time-slot-card__badge";
          badgeEl.textContent = "Closes soon";
          el.appendChild(badgeEl);
        }
      }

      timeContainer.appendChild(el);
    });

    // Ensure roving tabindex has exactly one item with tabindex 0
    if (!selectedEl && firstAvailableEl) {
      firstAvailableEl.setAttribute("tabindex", "0");
    }

    // Wire up keyboard navigation for the grid
    bindTimeSlotKeyboard(timeContainer);

    if (hadFocus) {
      const target = selectedEl || firstAvailableEl;
      if (target) target.focus();
    }

    if (!isNoDateSelected && !hasAvailableSlots && !availabilityMessage) {
      DP.toggleError("No delivery slots available for this date. Choose another date.");
    }

    DP.syncSelectorDisplays();
  }

  function bindTimeSlotKeyboard(wrapper) {
    if (wrapper.dataset.deliveryKeyboardBound) return;
    wrapper.dataset.deliveryKeyboardBound = "true";

    wrapper.addEventListener("keydown", (event) => {
      const items = Array.from(wrapper.querySelectorAll(".time-slot-card:not(.muted)"));
      if (!items.length) return;

      const focused = document.activeElement;
      let idx = items.indexOf(focused);
      if (idx === -1) idx = 0;

      let nextIdx = idx;

      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          event.preventDefault();
          nextIdx = (idx + 1) % items.length;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          event.preventDefault();
          nextIdx = (idx - 1 + items.length) % items.length;
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          if (focused && !focused.classList.contains("muted")) focused.click();
          return;
        case "Home":
          event.preventDefault();
          nextIdx = 0;
          break;
        case "End":
          event.preventDefault();
          nextIdx = items.length - 1;
          break;
        default:
          return;
      }

      items.forEach((item, i) => {
        item.setAttribute("tabindex", i === nextIdx ? "0" : "-1");
      });
      items[nextIdx].focus();
    });
  }

  DP.renderTimeSlots = renderTimeSlots;
})();
